import React from "react";
import { CNavGroup, CNavItem, CNavTitle } from "@coreui/react";
// Linear (outline) nav icons — secondary surface per the icon design rule
// (solid on accent, linear on tabs/secondary). Replaces the filled CoreUI cil*
// icons that previously rendered here.
import {
  NavPanelIcon,
  NavHomeIcon,
  NavDoctorsIcon,
  NavOrdersIcon,
  NavPaymentsIcon,
  NavWorkersIcon,
  NavCashIcon,
  NavInventoryIcon,
  NavMaterialIcon,
  NavEquipmentIcon,
  NavSupplierIcon,
  NavBuyOrderIcon,
  NavUsageIcon,
} from "./components/ui/icons";

const _nav = [
  // {
  //   component: CNavItem,
  //   name: "Dashboard",
  //   to: "/dashboard",
  //   icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  //   badge: {
  //     color: "info",
  //     text: "NEW",
  //   },
  // },
  // {
  //   component: CNavTitle,
  //   name: "Theme",
  // },
  {
    component: CNavItem,
    name: "Panel",
    to: "/dashboard",
    icon: <NavPanelIcon />,
    requiredScope: "read:dashboard",
  },
  {
    component: CNavItem,
    name: "Solicitudes de costo",
    to: "/cost-requests",
    icon: (
      <svg
        className="nav-icon"
        width={18}
        height={18}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 6h18M3 12h18M3 18h12" />
        <circle cx="19" cy="18" r="3" />
      </svg>
    ),
    requiredScope: "read:order-all",
  },
  {
    component: CNavItem,
    name: "Notificaciones",
    to: "/notifications",
    icon: (
      <svg
        className="nav-icon"
        width={18}
        height={18}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      </svg>
    ),
    requiredScope: "read:order",
  },
  {
    component: CNavItem,
    name: "Inicio",
    to: "/",
    icon: <NavHomeIcon />,
    requiredScope: "read:printer",
  },
  {
    component: CNavItem,
    name: "Doctores",
    to: "/doctor",
    icon: <NavDoctorsIcon />,
    requiredScope: "read:doctor",
  },
  {
    component: CNavItem,
    name: "Ordenes",
    to: "/order",
    icon: <NavOrdersIcon />,
    requiredScope: "read:order",
  },
  {
    component: CNavItem,
    name: "Pagos",
    to: "/payment",
    icon: <NavPaymentsIcon />,
    requiredScope: "read:payment",
  },
  {
    component: CNavItem,
    name: "Trabajadores",
    to: "/employee",
    icon: <NavWorkersIcon />,
    requiredScope: "read:employee",
  },
  {
    component: CNavItem,
    name: 'Caja',
    to: '/reports/cash-cut',
    icon: <NavCashIcon />,
    requiredScope: "read:cash-cut",
  },
  {
    // Inventory read-scopes are admin-only today (granted as a set in Auth0).
    // Gate the GROUP on read:material so non-admins don't see an empty group —
    // navFilter recurses into `items` but keeps an emptied group otherwise.
    component: CNavGroup,
    name: "Inventario",
    icon: <NavInventoryIcon />,
    requiredScope: "read:material",
    items: [
      {
        component: CNavItem,
        name: "Materiales",
        to: "/inventory/material",
        icon: <NavMaterialIcon />,
        requiredScope: "read:material",
      },
      {
        component: CNavItem,
        name: "Equipos",
        to: "/inventory/equipment",
        icon: <NavEquipmentIcon />,
        requiredScope: "read:equipment",
      },
      {
        component: CNavItem,
        name: "Proveedores",
        to: "/inventory/supplier",
        icon: <NavSupplierIcon />,
        requiredScope: "read:supplier",
      },
      {
        component: CNavItem,
        name: "Órdenes de compra",
        to: "/inventory/buy-order",
        icon: <NavBuyOrderIcon />,
        requiredScope: "read:buy-order",
      },
      {
        component: CNavItem,
        name: "Uso de materiales",
        to: "/inventory/usage-log",
        icon: <NavUsageIcon />,
        requiredScope: "read:usage-log",
      },
    ],
  },

  // {
  //   component: CNavTitle,
  //   name: "Components",
  // },
  // {
  //   component: CNavGroup,
  //   name: "Base",
  //   to: "/base",
  //   icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: "Accordion",
  //       to: "/base/accordion",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Breadcrumb",
  //       to: "/base/breadcrumbs",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Cards",
  //       to: "/base/cards",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Carousel",
  //       to: "/base/carousels",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Collapse",
  //       to: "/base/collapses",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "List group",
  //       to: "/base/list-groups",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Navs & Tabs",
  //       to: "/base/navs",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Pagination",
  //       to: "/base/paginations",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Placeholders",
  //       to: "/base/placeholders",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Popovers",
  //       to: "/base/popovers",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Progress",
  //       to: "/base/progress",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Spinners",
  //       to: "/base/spinners",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Tables",
  //       to: "/base/tables",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Tooltips",
  //       to: "/base/tooltips",
  //     },
  //   ],
  // },
  // {
  //   component: CNavGroup,
  //   name: "Buttons",
  //   to: "/buttons",
  //   icon: <CIcon icon={cilCursor} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: "Buttons",
  //       to: "/buttons/buttons",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Buttons groups",
  //       to: "/buttons/button-groups",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Dropdowns",
  //       to: "/buttons/dropdowns",
  //     },
  //   ],
  // },
  // {
  //   component: CNavGroup,
  //   name: "Forms",
  //   icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: "Form Control",
  //       to: "/forms/form-control",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Select",
  //       to: "/forms/select",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Checks & Radios",
  //       to: "/forms/checks-radios",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Range",
  //       to: "/forms/range",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Input Group",
  //       to: "/forms/input-group",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Floating Labels",
  //       to: "/forms/floating-labels",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Layout",
  //       to: "/forms/layout",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Validation",
  //       to: "/forms/validation",
  //     },
  //   ],
  // },
  // {
  //   component: CNavItem,
  //   name: "Charts",
  //   to: "/charts",
  //   icon: <CIcon icon={cilChartPie} customClassName="nav-icon" />,
  // },
  // {
  //   component: CNavGroup,
  //   name: "Icons",
  //   icon: <CIcon icon={cilStar} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: "CoreUI Free",
  //       to: "/icons/coreui-icons",
  //       badge: {
  //         color: "success",
  //         text: "NEW",
  //       },
  //     },
  //     {
  //       component: CNavItem,
  //       name: "CoreUI Flags",
  //       to: "/icons/flags",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "CoreUI Brands",
  //       to: "/icons/brands",
  //     },
  //   ],
  // },
  // {
  //   component: CNavGroup,
  //   name: "Notifications",
  //   icon: <CIcon icon={cilBell} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: "Alerts",
  //       to: "/notifications/alerts",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Badges",
  //       to: "/notifications/badges",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Modal",
  //       to: "/notifications/modals",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Toasts",
  //       to: "/notifications/toasts",
  //     },
  //   ],
  // },
  // {
  //   component: CNavItem,
  //   name: "Widgets",
  //   to: "/widgets",
  //   icon: <CIcon icon={cilCalculator} customClassName="nav-icon" />,
  //   badge: {
  //     color: "info",
  //     text: "NEW",
  //   },
  // },
  // {
  //   component: CNavTitle,
  //   name: "Extras",
  // },
  // {
  //   component: CNavGroup,
  //   name: "Pages",
  //   icon: <CIcon icon={cilStar} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: "Login",
  //       to: "/login",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Register",
  //       to: "/register",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Error 404",
  //       to: "/404",
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Error 500",
  //       to: "/500",
  //     },
  //   ],
  // },
  // {
  //   component: CNavItem,
  //   name: "Docs",
  //   href: "https://coreui.io/react/docs/templates/installation/",
  //   icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  // },
];

export default _nav;
